import { t as tr } from '../i18n.js'
import { useQuery } from '@tanstack/react-query'
import { Link, useSearchParams } from 'react-router'
import { api, type SearchResults } from '../api.js'

export function SearchPage() {
  const [params] = useSearchParams()
  const q = params.get('q')?.trim() ?? ''
  const r = useQuery({ queryKey: ['search', q], queryFn: () => api<SearchResults>(`/search?q=${encodeURIComponent(q)}`), enabled: q.length > 0 })
  return (
    <>
      <h1>{tr("Search")}</h1>
      <p className="muted">{q ? <>Results for <strong>{q}</strong></> : 'Type in the search box above — task keys (DEN-12), titles, projects and people.'}</p>
      {r.data && (
        <>
          <section className="card stack"><h2>Tasks · {r.data.tasks.length}</h2>
            {r.data.tasks.length === 0 && <p className="muted small">{tr("No tasks.")}</p>}
            {r.data.tasks.map((t) => <div key={t.id} className="row between small"><span><Link to={`/projects/${t.projectId}?task=${t.id}`}><span className="mono muted">{t.key}</span> {t.title}</Link></span><span className="muted">{t.statusName}{t.assigneeName ? ` · ${t.assigneeName}` : ''}{t.dueOn ? ` · due ${t.dueOn}` : ''}</span></div>)}
          </section>
          <section className="card stack"><h2>Projects · {r.data.projects.length}</h2>
            {r.data.projects.length === 0 && <p className="muted small">{tr("No projects.")}</p>}
            {r.data.projects.map((p) => <div key={p.id} className="small"><Link to={`/projects/${p.id}`}><strong>{p.code}</strong> {p.name}</Link> <span className="muted">· {p.status.replace('_', ' ')}</span></div>)}
          </section>
          {r.data.people.length > 0 && (
            <section className="card stack"><h2>People · {r.data.people.length}</h2>
              {r.data.people.map((u) => <div key={u.id} className="small">{u.displayName} <span className="muted">· {u.email} · {u.role}</span></div>)}
            </section>
          )}
        </>
      )}
    </>
  )
}
